const { default: axiosIns } = require('@/libs/axios')

const PerformanceReportService = {
  async getPerformanceReport(filter) {
    return axiosIns.post('/admin/performance-report', filter)
      .then(response => response.data)
  },
  async exportCsv(data) {
    return axiosIns.post('/admin/performance-report/export/csv', data, { responseType: 'blob' })
      .then(response => response.data)
  },
  async exportExcel(data) {
    return axiosIns.post('/admin/performance-report/export/excel', data, { responseType: 'blob' })
      .then(response => response.data)
  },
  async exportPdf(data, params) {
    return axiosIns.post(`/admin/performance-report/export/pdf?${params.toString()}`, data, { responseType: 'blob' })
      .then(response => response.data)
  },
}
export default PerformanceReportService
